var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRibbon = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "display/small/custom/ribbon3 copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3Nickels-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Small",
    transform: "translate(-1038, -4228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "display/small/custom/ribbon3-copy",
    transform: "translate(1038, 4228)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("g", {
    id: "badge-copy",
    transform: "translate(4, 2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0008222,0 C6.75473232,0 3.30065918,3.40166667 3.30065918,7.58333333 C3.30065918,11.765 6.75473232,15.1666667 11.0008222,15.1666667 C15.2469121,15.1666667 18.7009853,11.765 18.7009853,7.58333333 C18.7009853,3.40166667 15.2469121,0 11.0008222,0 Z M15.1666104,7.32008333 L13.6694787,8.83133333 L14.0247863,10.9741667 C14.0753873,11.28075 13.9444846,11.5895 13.6848791,11.7693333 C13.5440761,11.8668333 13.3768725,11.9166667 13.210769,11.9166667 C13.0732661,11.9166667 12.9357632,11.8830833 12.8114606,11.8148333 L11.0008222,10.8300833 L9.19018389,11.8159167 C8.91407805,11.9665 8.57307082,11.9491667 8.31566537,11.7693333 C8.0571599,11.5895 7.92625713,11.28075 7.97575818,10.9741667 L8.3310657,8.83133333 L6.83503402,7.32008333 C6.61942946,7.10233333 6.54462787,6.78275 6.64362997,6.49458333 C6.74153204,6.20533333 6.9945374,5.99625 7.3014439,5.94966667 L9.33758701,5.64308333 L10.2550064,3.718 C10.5256122,3.14708333 11.4771323,3.14708333 11.7477381,3.718 L12.6651575,5.64308333 L14.7013006,5.94966667 C15.0071071,5.99516667 15.2612124,6.20533333 15.3591145,6.49458333 C15.4570166,6.78275 15.382215,7.10233333 15.1666104,7.32008333 L15.1666104,7.32008333 Z",
    id: "Shape",
    fill: "#F2AE18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.35668154,14.0616667 L0.0995913946,21.5908333 C-0.0434116335,21.8508333 -0.0324114006,22.1758333 0.132592093,22.425 C0.297595587,22.6741667 0.583601644,22.8258333 0.891608166,22.7933333 L4.27967991,22.5441667 L5.77571159,25.545 C5.91871462,25.8158333 6.19372044,25.9891667 6.49072673,26 L6.5127272,26 C6.80973349,26 7.09573954,25.8375 7.23874257,25.5883333 L10.0108013,20.735 L7.3157442,16.0441667 C6.20472067,15.5783333 5.20369948,14.8958333 4.35668154,14.0616667 Z",
    id: "Path",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8910528,21.5908333 L17.600962,14.105 C16.2039324,15.4808333 14.3668935,16.4125 12.3208502,16.6941667 C11.8918411,16.7591667 11.4518318,16.7916667 11.0008222,16.7916667 C10.516812,16.7916667 10.043802,16.7591667 9.58179219,16.6833333 L10.9568213,19.0775 L14.6859003,25.5883333 C14.8289033,25.8375 15.1039091,26 15.4009154,26 L15.4229159,26 C15.7309224,25.9891667 16.0059282,25.8158333 16.1489312,25.545 L17.6559632,22.5441667 L21.1100363,22.8041667 C21.4180428,22.8258333 21.7040489,22.685 21.8690524,22.425 C22.0340559,22.1758333 22.0450561,21.8508333 21.8910528,21.5908333 L21.8910528,21.5908333 Z",
    id: "Path",
    fill: "#1B7690"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRibbon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ribbon.3df23eef75f35ac57233abe8b532796d.svg";